module.exports = __webpack_public_path__ + "static/media/bg-02.80690cbe.jpg";